import {formatDateTime} from "./formatDateTime";

export const formatDate = (date: Date, format: string = "DD.MM.YYYY"): string => {
  return formatDateTime(date, format);
};